import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';

interface PrompterReport {
    active: number;
    captureTime: any;
    createdAt: any;
    employeeId: string;
    productionOrderId: string;
    reportDate: any;
    /*shipId: string;*/
    updatedAt: any;
    captureUser?: string;
}

interface PrompterReportId extends PrompterReport {
    id: string;
}

interface EmployeeReport {
    activitiesCapture: number;
    activityId: any;
    activityName: string;
    captureTime: any;
    createdAt: any;
    employeeId: string;
    employeeName: string;
    shipId: any;
    shipName: string;
    updatedAt: any;
    workShiftId: any;
    workShiftName: any;
}

interface EmployeeReportId extends EmployeeReport {
    id: string;
}

@Injectable()
export class PrompterReportService {

    prompterReportCollection: AngularFirestoreCollection<PrompterReport>;
    prompterReports: any;

    prompterReportDocument: AngularFirestoreDocument<PrompterReportId>;
    prompterReport: Observable<any>;

    employeeReportCollection: AngularFirestoreCollection<EmployeeReport>;
    employeesReport: any;

    collection: string;
    collectionProductionOrder: string;
    collectionEmployee: string;
    collectionShip: string;

    constructor(private afs: AngularFirestore) {
        this.collection = Globals.PROMPTER_REPORT_COLLECTION;
        this.collectionProductionOrder = Globals.PRODUCTION_ORDER_COLLECTION;
        this.collectionEmployee = Globals.EMPLOYEE_COLLECTION;
        this.collectionShip = Globals.SHIP_COLLECTION;
    }

    postPrompterReport(prompterReportObject: any) {
        this.prompterReportCollection = this.afs.collection(this.collection);

        return this.prompterReportCollection.add(prompterReportObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getPrompterReports({limit=0}={}) {
        if(!limit){
            this.prompterReportCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', 1));
        }else{
            this.prompterReportCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', 1)/* .orderBy('createdAt', 'desc') */.limit(limit));
        }

        this.prompterReports = this.prompterReportCollection.snapshotChanges().map(actions => {
            console.log('actions', actions)
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as PrompterReport;

                const productionOrderId = data.productionOrderId;
                const employeeId = data.employeeId;
                /*const shipId = data.shipId;*/
                const reportDate = data.reportDate;
                const captureUser = data.captureUser;
                const captureTime = data.captureTime;

                return { id$, productionOrderId, employeeId, /*shipId,*/ reportDate, captureUser, captureTime };
            });
        }).map(documents => {
            return documents.map(document => {
                const productionOrder = this.afs.doc(this.collectionProductionOrder + '/' + document.productionOrderId).
                                        snapshotChanges().map(doc => {
                    const data = doc.payload.data();
                    const productionOrderName = data.name;
                    return { productionOrderName };
                });

                const employee = this.afs.doc(this.collectionEmployee + '/' + (document.employeeId || 'null')).snapshotChanges().map(doc => {
                    const data = doc.payload.exists ? doc.payload.data() : null;
                    const employeeName = data ? data.name + ' ' + data.lastName : '';
                    return { employeeName };
                });

                /*const ship = this.afs.doc(this.collectionShip + '/' + document.shipId).snapshotChanges().map(doc => {
                    const data = doc.payload.data();
                    const shipName = data.name;
                    const shipDescription = data.description;
                    return { shipName, shipDescription };
                });*/

                const employeesRef = this.afs.doc(this.collection + '/' + document.id$).collection('employees')
                                     .snapshotChanges().map(docs => {
                    return docs.map(item => {
                        const id$ = item.payload.doc.id;
                        return { id$ };
                    });
                });

                return Observable.combineLatest(productionOrder, employee, /*ship,*/ employeesRef,
                                                (productionOrderData, employeeData, /*shipData,*/ employeesData) => {
                    return {
                        productionOrder: productionOrderData,
                        employee: employeeData,
                        /*ship: shipData,*/
                        employees: employeesData
                    };
                }).map(data => {
                    return {
                        productionOrderObj: data.productionOrder,
                        employeeObj: data.employee,
                        /*shipObj: data.ship,*/
                        employees: data.employees,
                        ...document
                    };
                });
            });
        }).mergeMap(object => {
            return object.length === 0 ? Observable.of([]) : Observable.combineLatest(object);
        });

        return this.prompterReports;
    }

    getPrompterReport(prompterId: string) {
        this.prompterReportDocument = this.afs.doc(this.collection + '/' + prompterId);

        this.prompterReport = this.prompterReportDocument.snapshotChanges().map(action => {
            const id = action.payload.id;

            const data = action.payload.data() as PrompterReport;

            return { id, ...data };
        }).map(document => {
            const productionOrder = this.afs.doc(this.collectionProductionOrder + '/' + document.productionOrderId).
                                    snapshotChanges().map(doc => {
                const data = doc.payload.data();
                const productionOrderName = data.name;
                return { productionOrderName };
            });

            const employee = this.afs.doc(this.collectionEmployee + '/' + (document.employeeId || 'null')).snapshotChanges().map(doc => {
                const data = doc.payload.exists ? doc.payload.data() : null;
                const employeeName = data ? data.name + ' ' + data.lastName : '';
                return { employeeName };
            });

            /*const ship = this.afs.doc(this.collectionShip + '/' + document.shipId).snapshotChanges().map(doc => {
                const data = doc.payload.data();
                const shipName = data.name;
                const shipDescription = data.description;
                return { shipName, shipDescription };
            });*/

            return Observable.combineLatest(productionOrder, employee, /*ship,*/ (productionOrderData, employeeData/*, shipData*/) => {
                return {
                    productionOrder: productionOrderData,
                    employee: employeeData,
                    /*ship: shipData*/
                };
            }).map(data => {
                return {
                    productionOrderObj: data.productionOrder,
                    employeeObj: data.employee,
                    /*shipObj: data.ship,*/
                    ...document
                };
            });
        }).mergeMap(object => Observable.combineLatest(object));

        return this.prompterReport;
    }

    putPrompterReport(prompterReportObject: any, id$: string) {
        this.prompterReportCollection = this.afs.collection(this.collection);

        return this.prompterReportCollection.doc(id$).update(prompterReportObject).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    /*
    // Method to delete the register from DB
    delPrompterReport(id$: string) {
        this.prompterReportDocument = this.afs.doc(this.collection + '/' + id$);

        return this.prompterReportDocument .delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }
    */

    delPrompterReport(id$: string) {
        if(!confirm('¿Desea eliminar?')) return;
        this.prompterReportCollection = this.afs.collection(this.collection);

        return this.prompterReportCollection.doc(id$).update({ active: 0, updatedAt: new Date() }).then(function() {
            // console.log('Document updated');
        }).catch(function(error) {
            // console.error('Error updating document: ', error);
        });
    }

    postEmployeeReport(employeeReportObject: any, prompterReportId: string) {
        this.prompterReportCollection = this.afs.collection(this.collection);

        return this.prompterReportCollection.doc(prompterReportId).collection('employees').
                                              add(employeeReportObject).then(function(docRef) {
            // console.log('Document added with ID: ', docRef.id);
            return docRef.id;
        }).catch(function(error) {
            // console.error('Error adding document: ', error);
        });
    }

    getEmployeesReport(prompterReportId: string) {;
        this.employeeReportCollection = this.afs.doc(this.collection + '/' + prompterReportId).
            collection('employees', ref => ref.orderBy('createdAt', 'desc'));

        this.employeesReport = this.employeeReportCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as EmployeeReport;

                const employeeName = data.employeeName;
                const activityName = data.activityName;
                let workShiftName = '';
                if (data.activitiesCapture === 1) {
                    workShiftName = data.captureTime;
                } else {
                    workShiftName = data.workShiftName;
                }
                const employeeId = data.employeeId;
                const captureTime = data.captureTime;
                const shipName = data.shipName;

                return { id$, employeeName, activityName, workShiftName, employeeId, captureTime, shipName };
            });
        }).map(object => object);

        return this.employeesReport;
    }

    delEmployeeReport(id$: string, prompterReportId: string) {
        return this.afs.collection(this.collection).doc(prompterReportId).collection('employees').doc(id$).delete().then(function() {
            // console.log('Document deleted');
        }).catch(function(error) {
            // console.error('Error deleting document: ', error);
        });
    }

    getPrompterReportsByReportDate(iReportDate: any) {
        this.prompterReportCollection = this.afs.collection(this.collection,
            ref => ref.where('active', '==', 1).where('reportDate', '==', iReportDate));

        this.prompterReports = this.prompterReportCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as PrompterReport;

                const reportDate = data.reportDate;
                const captureTime = data.captureTime;
                /*const shipId = data.shipId;*/

                return { id$, reportDate, captureTime/*, shipId*/ };
            });
        }).map(documents => {
            return documents.map(document => {
                this.employeeReportCollection = this.afs.doc(this.collection + '/' + document.id$).
                                                collection('employees', ref => ref.orderBy('createdAt', 'desc'));

                const employeesRef = this.employeeReportCollection.snapshotChanges().map(actions => {
                    return actions.map(a => {
                        const id$ = a.payload.doc.id;

                        const data = a.payload.doc.data() as EmployeeReport;

                        const employeeId = data.employeeId;
                        const employeeName = data.employeeName;
                        const captureTime = data.captureTime;

                        return { id$, employeeId, employeeName, captureTime };
                    });
                });

                return Observable.combineLatest(employeesRef, (employeesData) => {
                    return {
                        employees: employeesData
                    };
                }).map(data => {
                    return {
                        employees: data.employees,
                        ...document
                    };
                });
            });
        }).mergeMap(object => {
            return object.length === 0 ? Observable.of([]) : Observable.combineLatest(object);
        });

        return this.prompterReports;
    }

    getPrompterReportsSinceReportDate(iReportDate: any) {
        this.prompterReportCollection = this.afs.collection(this.collection, ref => ref.where('active', '==', 1)
                                        .where('reportDate', '>=', iReportDate));

        this.prompterReports = this.prompterReportCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as PrompterReport;

                const productionOrderId = data.productionOrderId;
                const employeeId = data.employeeId;
                /*const shipId = data.shipId;*/
                const reportDate = data.reportDate;
                const captureUser = data.captureUser;
                const captureTime = data.captureTime;

                return { id$, productionOrderId, employeeId, /*shipId,*/ reportDate, captureUser, captureTime };
            });
        }).map(documents => {
            return documents.map(document => {
                const productionOrder = this.afs.doc(this.collectionProductionOrder + '/' + document.productionOrderId).
                                        snapshotChanges().map(doc => {
                    const data = doc.payload.data();
                    const productionOrderName = data.name;
                    return { productionOrderName };
                });

                const employee = this.afs.doc(this.collectionEmployee + '/' + (document.employeeId || 'null')).snapshotChanges().map(doc => {
                    const data = doc.payload.exists ? doc.payload.data() : null;
                    const employeeName = data ? data.name + ' ' + data.lastName : '';
                    return { employeeName };
                });

                /*const ship = this.afs.doc(this.collectionShip + '/' + document.shipId).snapshotChanges().map(doc => {
                    const data = doc.payload.data();
                    const shipName = data.name;
                    const shipDescription = data.description;
                    return { shipName, shipDescription };
                });*/

                const employeesRef = this.afs.doc(this.collection + '/' + document.id$).collection('employees')
                                    .snapshotChanges().map(docs => {
                    return docs.map(item => {
                        const id$ = item.payload.doc.id;
                        return { id$ };
                    });
                });

                return Observable.combineLatest(productionOrder, employee, /*ship,*/ employeesRef,
                                                (productionOrderData, employeeData, /*shipData,*/ employeesData) => {
                    return {
                        productionOrder: productionOrderData,
                        employee: employeeData,
                        /*ship: shipData,*/
                        employees: employeesData
                    };
                }).map(data => {
                    return {
                        productionOrderObj: data.productionOrder,
                        employeeObj: data.employee,
                        /*shipObj: data.ship,*/
                        employees: data.employees,
                        ...document
                    };
                });
            });
        }).mergeMap(object => {
            return object.length === 0 ? Observable.of([]) : Observable.combineLatest(object);
        });

        return this.prompterReports;
    }

}
